import { RootState } from "app/store";
import { COUNTRY_JP } from "common/constants";
import { validateFurigana } from "common/validateFurigana";
import { validatePassword } from "common/validatePassword";
import { validateRequiredField } from "common/validateRequiredField";
import { validatePostalCode } from "common/validatePostalCode";
import { validateTelephoneNumber } from "common/validateTelephoneNumber";
import { ErrorChacekResults } from "./types";

export const selectPasswordValidationErrors = (state: RootState) => {
  const { newPassword, newPasswordCheck } = state.profile.apps;
  return validatePassword(newPassword, newPasswordCheck);
};
export const selectCurrentPassword = (state: RootState) =>
  state.profile.apps.currentPassword;
export const selectNewPassword = (state: RootState) =>
  state.profile.apps.newPassword;
export const selectNewPasswordCheck = (state: RootState) =>
  state.profile.apps.newPasswordCheck;
export const selectEmail = (state: RootState) => state.profile.apps.email;
export const selectCountry = (state: RootState) => state.profile.apps.country;
export const selectFamilyName = (state: RootState) =>
  state.profile.apps.familyName;
export const selectFirstName = (state: RootState) =>
  state.profile.apps.firstName;
export const selectFamilyNameFurigana = (state: RootState) =>
  state.profile.apps.familyNameFurigana;
export const selectFirstNameFurigana = (state: RootState) =>
  state.profile.apps.firstNameFurigana;
export const selectCompany = (state: RootState) => state.profile.apps.company;
export const selectCompanyFurigana = (state: RootState) =>
  state.profile.apps.companyFurigana;
export const selectOffice = (state: RootState) => state.profile.apps.office;
export const selectDdepartment = (state: RootState) =>
  state.profile.apps.department;
export const selectPosition = (state: RootState) => state.profile.apps.position;
export const selectJobType = (state: RootState) => state.profile.apps.jobType;
export const selectCompanyTel = (state: RootState) =>
  state.profile.apps.companyTel;
export const selectPostalCode = (state: RootState) =>
  state.profile.apps.postalCode;
export const selectState = (state: RootState) => state.profile.apps.state;
export const selectCity = (state: RootState) => state.profile.apps.city;
export const selectAddress = (state: RootState) => state.profile.apps.address;
export const selectBuildingName = (state: RootState) =>
  state.profile.apps.buildingName;
export const selectMarket_Status = (state: RootState) =>
  state.profile.apps.market_status;
export const selectPostalError = (state: RootState) =>
  state.profile.apps.postalError;
export const selectInputValidationErrors = (
  state: RootState
): ErrorChacekResults => {
  const { apps } = state.profile;
  // 必須項目のチェック
  const hasErrorEmptyCountry = validateRequiredField(apps.country);
  const hasErrorEmptyName =
    validateRequiredField(apps.familyName) ||
    validateRequiredField(apps.firstName);
  const hasErrorEmptyCompany = validateRequiredField(apps.company.trim());
  const hasErrorEmptyState = validateRequiredField(apps.state);
  const hasErrorEmptyCity = validateRequiredField(apps.city);

  const { hasErrorEmptyPostalCode, hasErrorIncorrectPostalCode } =
    validatePostalCode(apps.postalCode);
  const hasErrorIncorrectTelephoneNumber = validateTelephoneNumber(
    apps.companyTel
  );

  // 日本の場合はフリガナもチェックする
  if (apps.country === COUNTRY_JP) {
    // 名前系チェックを行う
    const hasErrorFirstNameFurigana =
      apps.firstNameFurigana === undefined || apps.firstNameFurigana === ""
        ? false
        : validateFurigana(apps.firstNameFurigana);
    const hasErrorFamilyNameFurigana =
      apps.familyNameFurigana === undefined || apps.familyNameFurigana === ""
        ? false
        : validateFurigana(apps.familyNameFurigana);
    const hasErrorIncorrectNameFurigana =
      hasErrorFirstNameFurigana || hasErrorFamilyNameFurigana;
    // 企業名チェックを行う
    const hasErrorIncorrectCompanyFurigana =
      apps.companyFurigana === undefined || apps.companyFurigana === ""
        ? false
        : validateFurigana(apps.companyFurigana);

    return {
      hasErrorEmptyCountry,
      hasErrorEmptyName,
      hasErrorEmptyCompany,
      hasErrorEmptyPostalCode,
      hasErrorEmptyState,
      hasErrorEmptyCity,
      hasErrorIncorrectNameFurigana,
      hasErrorIncorrectCompanyFurigana,
      hasErrorIncorrectPostalCode,
      hasErrorIncorrectTelephoneNumber,
    };
  }
  return {
    hasErrorEmptyCountry,
    hasErrorEmptyName,
    hasErrorEmptyCompany,
    hasErrorEmptyPostalCode,
    hasErrorEmptyState,
    hasErrorEmptyCity,
    hasErrorIncorrectPostalCode,
    hasErrorIncorrectTelephoneNumber,
  };
};
